import React, { useEffect, useState } from 'react';
import FaiBox from "../../../../MuiComponents/FaiBox";
import {Stack, TextField} from "@mui/material";
import FaiButton from "../../../../MuiComponents/FaiButton";
import Icon from "@mui/material/Icon";
import Strip from "../../../../components/Strip";
import FaiSelect from "../../../../MuiComponents/FaiSelect";
import { ProductController } from '../../../../controllers/productController';
import { merchantAuthController } from '../../../../controllers/authController';

interface HeaderBarProps {
    onFilterChange: (filters: any) => void;
    // Delivery statuses present in the merchant's orders, for the status filter.
    statuses?: string[];
}

function HeaderBar({ onFilterChange, statuses = [] }: HeaderBarProps) {
    const [selectedStatus, setSelectedStatus] = useState('');
    const [orderIdInput, setOrderIdInput] = useState('');
    const [brand, setBrands] = useState([]);
    const [category, setCategory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedBrand, setSelectedBrand] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [skuInput, setSkuInput] = useState('');

    useEffect(() => {
        const fetchBrands = async () => {
            try {
                const apiResponse: any = await merchantAuthController.getBrandList();
                console.log('Brand List:', apiResponse.data.data.data);
                const categoryOptions = apiResponse.data.data.data.map(category => ({
                    value: category.brandName,
                    label: category.brandName
                }));
                setBrands(categoryOptions);
            } catch (error) {
                console.error('Error fetching coupons:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchBrands();
    }, []);

    const brandCategory = async (brandName: string) => {
        try {
            setLoading(true);
            const response = await ProductController.getMasterCategoriesByBrand(brandName);

            if (response.data && response.data.data && response.data.data.masterCategories) {
                const stateOptions = response.data.data.masterCategories.map((state: any) => ({
                    value: state.name,
                    label: state.name,
                    id: state.id
                }));
                setCategory(stateOptions);
            }
        } catch (error) {
            console.error('Error fetching states:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleBrandChange = (selectedOption) => {
        setSelectedBrand(selectedOption.value);
        setSelectedCategory('');
        setSkuInput('');
        setCategory([]);
        brandCategory(selectedOption.value);
    };

    const handleCategoryChange = (selectedOption) => {
        setSelectedCategory(selectedOption.value);
    };

    const handleFilter = () => {
        const filters: any = {};
        if (selectedBrand) filters.brand = selectedBrand;
        if (selectedStatus) filters.status = selectedStatus;
        if (orderIdInput) filters.orderId = orderIdInput;
        if (skuInput) filters.sku = skuInput;
        onFilterChange(filters);
    };

    const handleReset = () => {
        setSelectedBrand('');
        setSelectedCategory('');
        setSkuInput('');
        setCategory([]);
        setSelectedStatus('');
        setOrderIdInput('');
        onFilterChange({});
    };
  
    return (
        <>
            <FaiBox>
                <Strip>
                    <FaiBox p={"10px 10px"}>
                        <FaiBox display={"flex"} alignItems={"center"} justifyContent="space-between">
                            <FaiBox>
                                <Stack spacing={1} direction="row">
                                    <FaiSelect
                                        placeholder="Brand Name"
                                        options={brand}
                                        onChange={handleBrandChange}
                                        value={selectedBrand ? { value: selectedBrand, label: selectedBrand } : null}
                                    />
                                    {/* Orders carry no product category, so the old Category box could
                                        never match anything. Status is what merchants look for here. */}
                                    <FaiSelect
                                        placeholder="Order status"
                                        options={statuses.map((s) => ({ value: s, label: s }))}
                                        onChange={(option: any) => setSelectedStatus(option?.value ?? '')}
                                        value={selectedStatus ? { value: selectedStatus, label: selectedStatus } : null}
                                    />
                                    <TextField
                                        placeholder="Order ID"
                                        value={orderIdInput}
                                        onChange={(e) => setOrderIdInput(e.target.value)}
                                    />
                                    <TextField
                                        placeholder="Product SKU"
                                        value={skuInput}
                                        onChange={(e) => setSkuInput(e.target.value)}
                                    />
                                </Stack>
                            </FaiBox>
                            <FaiBox display={"flex"} alignItems={"center"} justifyContent="space-between">
                                <FaiBox>
                                    <Stack spacing={1} direction="row">
                                        <FaiButton 
                                            sx={{
                                                padding: "7px 12px !important",
                                                height: "34px",
                                                minHeight: 0
                                            }} 
                                            variant="contained" 
                                            color="success"
                                            onClick={handleFilter}
                                        >
                                            <Icon sx={{ marginRight: "5px" }}>
                                                filter_alt_outlined
                                            </Icon> 
                                            Filter
                                        </FaiButton>
                                        <FaiButton 
                                            sx={{
                                                padding: "7px 12px !important",
                                                height: "34px",
                                                minHeight: 0
                                            }} 
                                            variant="contained" 
                                            color="dark"
                                            onClick={handleReset}
                                        >
                                            Reset
                                        </FaiButton>
                                    </Stack>
                                </FaiBox>
                            </FaiBox>
                        </FaiBox>
                    </FaiBox>
                </Strip>
            </FaiBox>
        </>
    );
}

export default HeaderBar;
